if(!customElements.get('hotspot-slider')) {
  class ComponentHotspotSlider extends HTMLElement {
    constructor() {
      super();
      this.slidesWrapper = this.querySelector('.keen-slider');
      this.sliderNav = this.parentNode.querySelector('.keen-nav');
      this.sliderNavCurrent = this.sliderNav.querySelector('.current');
      this.slides = this.slidesWrapper.children;
      this.effect = this.dataset.effect;
      this.dots = this.dataset.dots;
      this.arrows = this.dataset.arrows;
      this.autoplay = this.dataset.autoplay;
      this.pauseOnHover = this.dataset.pauseOnHover!=='false';
      this.carousel = false;
      this.isInViewPort = false;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initCarousel();
      }, 1);

      this.querySelectorAll('.spot').forEach((item) => {
        item.addEventListener('click', this.selectProduct.bind(this))
        item.addEventListener('keypress', this.selectProduct.bind(this))
      })

      this.bindCustomizerEvents();

      window.addEventListener('resize', this.initSelection.bind(this));
      this.initSelection(); 
    }

    initSelection() {
      if($s.media.isMediumDown){
        this.querySelectorAll('.spot').forEach((spot) => spot.classList.remove('active'));
        return;
      }
      
      this.querySelectorAll('.keen-slider-slide').forEach((slide) => {
        slide.querySelectorAll('.spot')[0].click();
      });

    }

    selectProduct(e){
      if (e.type == 'keypress' && e.keyCode!=13) {
        e.preventDefault();
        return false;
      }
      const prodKey = e.target.dataset.productKey;
      const slide = e.target.closest('.keen-slider-slide');
      const productsWrapper = slide.querySelector('.products');
      const spots = slide.querySelectorAll('.spot');

      spots.forEach((spot) => spot.classList.remove('active'));

      e.target.classList.add('active');
      productsWrapper.querySelectorAll('.prod').forEach((item) => item.classList.remove('active'));
      productsWrapper.querySelector('[data-product-key="'+prodKey+'"]').classList.add('active');
      
    }

    initCarousel() {
      if(this.slides.length > 1) {
        this.carousel = new KeenSlider(this.slidesWrapper, {
          mode: "snap",
          loop: false,
          wheel: false,
          dots: this.dots ? this.querySelector('.keen-dots') : false,
          prevButton: this.arrows ? this.sliderNav.querySelector('.keen-arrow.prev') : false,
          nextButton: this.arrows ? this.sliderNav.querySelector('.keen-arrow.next') : false,
          customAnimation: this.effect=='fade' ? 'fade' : false,
          setContainerHeight: this.effect=='fade',
          autoplay: this.autoplay,
          pauseOnHover: this.pauseOnHover,
          slideChanged: (keen,i)=>{
            this.sliderNavCurrent.innerHTML = keen.details().absoluteSlide+1;
          }
        });
      } else {
        this.slidesWrapper.classList.add('initialized');
      }
    }

    getCurrentSlide() {
      if(this.carousel && this.carousel.currentSlide()) {
        return this.carousel.currentSlide();
      } else {
        return this.slidesWrapper.firstChild;
      }
    }

    bindCustomizerEvents() {
      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e)=>{
          let index = Array.from(this.slides).findIndex(x=>x==e.target);
          if(index>=0) {
            setTimeout(()=>{
              this.carousel.moveToSlideRelative(index, true, 0)
            }, 10);
          }
        });
      }
    }
  }
  customElements.define('hotspot-slider', ComponentHotspotSlider);
}